export default __webpack_public_path__ + "static/media/error.2e1f7036.svg";